export default __webpack_public_path__ + "static/1493-a0a2a7f2d6569f0d6a7331fec209136c.jpeg";